"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _ProductDetailContext = _interopRequireDefault(require("../context/ProductDetailContext"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _it = _interopRequireDefault(require("../../locals/it.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useDescriptions = function useDescriptions(_ref) {
  var exclude = _ref.exclude,
    _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? "de" : _ref$lang,
    type = _ref.type;
  var _useContext = (0, _react.useContext)(_ProductDetailContext.default),
    productDetailData = _useContext.productDetailData;
  var _ref2 = productDetailData || {},
    productDescriptions = _ref2.descriptions;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    descriptions = _useState2[0],
    setDescriptions = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    localsLoaded = _useState4[0],
    setLocalsLoaded = _useState4[1];
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(function () {
    if (!(0, _isEmpty.default)(l("reactShop"))) {
      setLocalsLoaded(true);
    }
  }, [l]);
  (0, _react.useEffect)(function () {
    var _descriptions = JSON.parse(JSON.stringify(productDescriptions !== null && productDescriptions !== void 0 ? productDescriptions : []));
    if (!_descriptions.length) return;
    if (exclude) {
      _descriptions = _descriptions.filter(function (description) {
        if (Array.isArray(exclude)) return exclude.indexOf(description.identifier) > -1 ? false : true;
        return (description === null || description === void 0 ? void 0 : description.identifier) !== exclude;
      });
      setDescriptions(_descriptions);
      return;
    }
    if (type) {
      if (Array.isArray(type)) {
        _descriptions = _descriptions.filter(function (description) {
          return type.indexOf(description.identifier) > -1;
        });
      } else {
        _descriptions = _descriptions.find(function (description) {
          return (description === null || description === void 0 ? void 0 : description.identifier) === type;
        });
      }
      setDescriptions(_descriptions);
      return;
    }
    setDescriptions(_descriptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(exclude), lang, localsLoaded, productDescriptions, JSON.stringify(type)]);
  return descriptions;
};
var _default = useDescriptions;
exports.default = _default;